import React, { useContext } from "react";
import { useHistory } from "react-router-dom";

import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { UserContext } from "../../context/userContext";


const Orden = () => {
  const { order, changeOrder } = useContext(UserContext);

  const history = useHistory();

  const handleDeliver = () => {
    //primeor revisar si ya hay bevbidas agregadas
    //Settear el tipo de envio
    //Dirigir a carrito o a menu segun el caso

    changeOrder({
      type: "ORDER_TYPE",
      payload: '0',
    });

    if (order.bebidas.length === 0) {
      history.push("/menu");

      //Envia al menu
    } else {
      //Envia al carrito
      history.push("/carrito");
    }
  };

  const handlePick = () => {
    changeOrder({
      type: "ORDER_TYPE",
      payload: '1',
    });

    if (order.bebidas.length === 0) {
      history.push("/menu");

      //Envia al menu
    } else {
      //Envia al carrito
      history.push("/carrito");
    }
  };

  // const handleSuc = () => {
  //   changeOrder({
  //     type: "ORDER_TYPE",
  //     payload: 2,
  //   });

  //   if (order.bebidas.length === 0) {
  //     history.push("/menu");

  //     //Envia al menu
  //   } else {
  //     //Envia al carrito
  //     history.push("/carrito");
  //   }
  // };

  return (
    <Card>
      {order.status ? (
        <Card.Body>Tienes un pedido en curso</Card.Body>
      ) : (
        <Card.Body>
          <Row className="justify-content-center">
            <Col xs="auto">
              <p className="titles">Haz tu pedido ahora</p>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col xs="auto" className="mt-3">
              <button className="button-text" onClick={handleDeliver}>
                Delivery
              </button>
            </Col>

            <Col xs="auto" className="mt-3">
              <button className="button-text" onClick={handlePick}>
                Pick'up
              </button>
            </Col>

            {/* <Col xs="auto" className="mt-3">
              <Button className="textBod" onClick={handleSuc}>
                En sucursal
              </Button>
            </Col> */}
          </Row>
        </Card.Body>
      )}
    </Card>
  );
};

export default Orden;
